import { api } from "./api";

export const TOKEN_KEY = "rikkus_token";
export const USER_KEY = "rikkus_user";

export async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(USER_KEY, JSON.stringify({ email: data.user_email }));
    return data;
}

export function logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
}

export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
    try {
        const raw = localStorage.getItem(USER_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function isAuthenticated() {
    const t = getToken();
    if (!t) return false;
    try {
        // Decode payload (unverified) to check exp
        const payload = JSON.parse(
            atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
        );
        const now = Math.floor(Date.now() / 1000);
        return payload.exp && payload.exp > now;
    } catch {
        return false;
    }
}
